export const getActivityBackground = (activity, withName) => {
    if (!activity) return '';

    if (withName)
        return activity.type === 'orientatie'
            ? { hex: '#9E7FC9', name: 'purple' }
            : activity.type === 'open-dagen'
            ? { hex: '#35B6DD', name: 'blue' }
            : { hex: '#46469A', name: 'purple-dark' };

    return activity.type === 'orientatie'
        ? '#9E7FC9'
        : activity.type === 'open-dagen'
        ? '#35B6DD'
        : '#46469A';
};
